<div class="related-categories__carousel-container">
  <div #categoryCardsCarousel class="related-categories__grid" (scroll)="updateArrowsVisibility()">
    <span
      (click)="clickLeftArrow(); onRelatedCategoriesCarouselNavigation()"
      *ngIf="leftArrowVisible"
      class="related-categories__grid__arrow"
    ><mm-icon name="chevron-small-left"></mm-icon></span>
    <app-related-category-card
      *ngFor="let category of categories"
      class="related-categories-card"
      [category]="category"
      [isMobile]="isMobile"
      [parentCategoryName]="parentCategory.name"
      appDisableClickEvent
    ></app-related-category-card>
    <span
      (click)="clickRightArrow(); onRelatedCategoriesCarouselNavigation()"
      *ngIf="rightArrowVisible"
      class="related-categories__grid__arrow"
    ><mm-icon name="chevron-small-right"></mm-icon></span>
  </div>
</div>
